export default "__VITE_ASSET__1FMVnVNm__"